/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var maxKeywordLength = 100;
var viewModel = function (isNegativeKeyword, isBmmBlockEnabled = false) {
  var self = this;
  self.parserSchema = {
    properties: {
      keywordsTextareaVal: {
        type: 'string'
      }
    }
  };
  self.isNegativeKeyword = isNegativeKeyword;
  self.isBmmBlockEnabled = isBmmBlockEnabled;
  self.isAfterFirstInteraction = ko.observable(false);
  self.showBmmWarningAlert = ko.observable(false);
  self.showMutableKeywordMatchTypAlert = ko.observable(false);
  self.showBmmBlockAlert = ko.observable(false);
  self.maxKeywords = 1000;
  self.numSeedKeywords = 3;
  self.seedKeywordTimeout = 2000;
  self.seedKeywords = ko.observable();
  self.parsedKeywords = ko.observable([]);
  self.uniqueParsedKeywords = ko.observable([]);
  self.parseKeywords = function (data, e) {
    self.isAfterFirstInteraction(true);
    var newKeywords = self.peekKeywords();
    self.parsedKeywords(newKeywords);
    if (_.size(newKeywords) > 0) {
      self.uniqueParsedKeywords(_.unique(newKeywords, false, function (keyword) {
        return keyword.toLowerCase();
      }));
    } else {
      self.uniqueParsedKeywords([]);
    }
    self.validate();
    return true;
  };
  self.peekKeywords = function () {
    var newKeywords = self.keywordsTextareaVal();
    if (!_.isString(newKeywords) || _.isEmpty(newKeywords) || _.isEmpty(newKeywords.replace(/[,\s]+/, ''))) {
      return [];
    }
    var splitChar = ',';
    newKeywords = newKeywords.replace(/((^[,\s]+)|([,\s]+$))/g, '');
    if (self.isNegativeKeyword) {
      newKeywords = newKeywords.replace(',', '%2C');
    } else if (newKeywords.indexOf(',') >= 0) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'createKeyword/parser', 'User has comma in keywords input. Input: ' + newKeywords);
    }
    newKeywords = newKeywords.replace(/([,\s]*[\n\r\,]+[,\s]*)/g, splitChar);
    newKeywords = newKeywords.replace(/[\t ]+(?=\]|\)|\")/g, '');
    newKeywords = newKeywords.replace(/(\[|\(|\")[\t ]+/g, '$1');
    newKeywords = newKeywords.replace(/\s+/g, ' ');
    var keywords = newKeywords.split(splitChar);
    if (self.isNegativeKeyword) {
      keywords = _.map(keywords, function (keyword) {
        return keyword.replace('%2C', ',');
      });
    }
    return keywords;
  };
  self.isBmmExist = function (keywords) {
    const target = keywords.find(keyword => {
      const wordsArr = keyword.split(' ');
      return wordsArr.find(words => (/^\++[^\+]/i).test(words));
    });
    return target !== undefined;
  };
  self.isKeywordsValid = _.partial(function (parser) {
    var keywords = parser.parsedKeywords();
    if (parser.isAfterFirstInteraction() && !keywords.length > 0) {
      this.message = i18n.get('Keyword_Message_NoKeywords');
      return false;
    }
    if (keywords.length > parser.maxKeywords) {
      this.message = i18n.get('Keyword_Message_MaxKeywords').replace('{0}', parser.maxKeywords);
      return false;
    }
    this.message = [];
    _.each(keywords, function (keyword) {
      var text = keyword;
      if ((/^".*"$/).test(text)) {
        text = text.replace(/\"/g, '');
      } else if ((/^\[.*\]$/).test(text)) {
        text = text.replace(/(\[|\])/g, '');
      } else if ((/^\(.*\)$/).test(text)) {
        text = text.replace(/\(|\)/g, '');
      }
      if (_.size(text) > maxKeywordLength) {
        this.message.push(i18n.getString('Keywords_And_Errors_seperator', _.escape(text.substring(0, 100) + '...'), i18n.getString('Keywords_Validation_KeywordTextLengthExceeded', maxKeywordLength)));
      }
    }, this);
    if (_.isArray(this.message) && _.size(this.message) > 0) {
      return false;
    }
    if (!self.isNegativeKeyword && self.isBmmBlockEnabled && self.isBmmExist(keywords)) {
      this.message.push(i18n.getString('Keywords_And_Errors_BroadMatchError'));
      return false;
    }
    return true;
  }, self);
  ko_schema.properties(self, self.parserSchema, ['keywordsTextareaVal'], {}, {
    'keywordsTextareaVal': {
      isValid: self.isKeywordsValid,
      message: i18n.get('AdGroup_Message_DuplicateKeywords')
    }
  });
  self.reset = function () {
    self.keywordsTextareaVal('');
    self.parsedKeywords([]);
    self.uniqueParsedKeywords([]);
    self.seedKeywords(null);
    self.isAfterFirstInteraction(false);
    self.isKeywordsValid(true);
    self.showBmmWarningAlert(false);
    self.showMutableKeywordMatchTypAlert(false);
    self.showBmmBlockAlert(false);
  };
};
export default viewModel;

